var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalTimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.367,
    height: 21.372,
    viewBox: "0 0 21.367 21.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "letter-x",
    d: "M.3,1.783A1.064,1.064,0,0,1,.3.3,1.064,1.064,0,0,1,1.785.3l8.9,8.91L19.591.3a1.043,1.043,0,1,1,1.467,1.482l-8.9,8.9,8.9,8.91a1.043,1.043,0,0,1-1.467,1.482l-8.91-8.91-8.9,8.91a1.064,1.064,0,0,1-1.482,0,1.064,1.064,0,0,1,0-1.482l8.9-8.91Z",
    transform: "translate(-0.002 0)",
    fill: "#1e201d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalTimes);
export default __webpack_public_path__ + "static/media/modal-times.3fd16fbc57d69b0d3b7aa88dc19380ba.svg";
export { ForwardRef as ReactComponent };